import tradeBlockDataStore from "@/store/tradeBlockDataStore";
import { getTransactionTypeValue } from "./transactionTypeFormatter";

const TransactionTypeCellRenderer = (params: any) => {
  const esid = params.colDef?.cellRendererParams?.fullTradeData?.esid;
  const blockId = params.data?.id;

  // Subscribe to Zustand store for reactive updates
  const currentTradeBlockData = tradeBlockDataStore(
    (state) => state.tradeBlockData,
  );

  // Trigger re-render when store changes by accessing the data
  const theseBlocks = currentTradeBlockData.find(
    (blocks) => blocks.esid === esid,
  );
  const thisBlock = theseBlocks?.blocks?.find((block) => block.id === blockId);

  // Use shared formatting logic
  const valueToReturn =
    esid && blockId != null ? getTransactionTypeValue(esid, blockId) : "";

  if (thisBlock?.instrumentType === "SWP") {
    return (
      <div data-testid="transactionTypeCellRenderer">{valueToReturn}</div>
    );
  }

  return <div data-testid="transactionTypeCellRenderer"></div>;
};

export default TransactionTypeCellRenderer;
